/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import Link from '@components/i18n/Link';

export const LocaleLink = ({ to, className, onClick, children }) => (
  <Link to={to} className={className} onClick={onClick}>
    {children}
  </Link>
);

LocaleLink.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any.isRequired,
};

LocaleLink.defaultProps = {
  className: undefined,
  onClick: undefined,
};
